<template>
  <div id="pripady-table-filter-wrapper" class="pb-6">
    <v-container class="pripady-table-filter pa-0">
      <h2 class="pt-10 pb-4">Filter</h2>
      <v-form autocomplete="off">
        <v-row no-gutters class="mx-n4">
          <v-col xl="3" lg="3" md="3" class="px-4">
            <DynamicCombo
              dynamic
              clearable
              data-id="liw_filip__obc_pripady__filter_stredisko"
              autoload
              outlined
              :cache="false"
              v-model="idStrediska"
              lite
            >
            </DynamicCombo
          ></v-col>
          <v-col xl="3" lg="3" md="3" class="px-4">
            <DynamicCombo
              dynamic
              clearable
              :cache="false"
              data-id="liw_filip__obc_pripady__filter_dodavatel"
              autoload
              outlined
              v-model="idDodavatela"
              lite
            >
            </DynamicCombo
          ></v-col>
          <v-col xl="3" lg="3" md="3" class="px-4">
            <date-picker
              placeholder="DD/MM/YYYY - DD/MM/YYYY"
              label="Dátum vytvorenia OP/LZ"
              v-model="datumVytvorenia"
              :cache="false"
              range
            ></date-picker>
          </v-col>
          <v-col xl="3" lg="3" md="3" class="px-4">
            <date-picker
              placeholder="DD/MM/YYYY - DD/MM/YYYY"
              label="Dátum modifikácie OP/LZ"
              v-model="datumModifikacie"
              :cache="false"
              range
            ></date-picker>
          </v-col>
        </v-row>
      </v-form>
      <v-row no-gutters>
        <v-col xl="8" lg="8" md="8">
          <v-btn-toggle multiple group v-model="stav" class="mt-2">
            <v-btn
              small
              v-for="({ nazov, hodnota }, index) in stavFilter"
              :key="index"
              :data-id="hodnota"
            >
              {{ nazov }}
              <v-icon right dark size="14" color="#0097FD"> mdi-check </v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col xl="4" lg="4" md="4">
          <!-- ############# -->
          <!-- DIALOG FILTER -->
          <!-- ############# -->
          <div class="right">
            <v-dialog v-model="dialog" max-width="400" overlay-color="black" overlay-opacity="0.8">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="btn-secondary btn-icon" v-bind="attrs" v-on="on">
                  <v-icon size="18">mdi-filter-menu-outline</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="headline"> Filter </v-card-title>
                <v-card-text class="px-6">
                  <v-form autocomplete="off">
                    <text-box label="Nájomca" :cache="false" v-model="najomca"></text-box>
                    <text-box label="Nájomca ičo" :cache="false" v-model="ico"></text-box>
                    <text-box
                      label="Číslo obch. prípadu"
                      :max="12"
                      :cache="false"
                      v-model="cisloObchPripadu"
                    ></text-box>
                    <text-box
                      label="Číslo plz"
                      :max="12"
                      :cache="false"
                      v-model="cisloPlz"
                    ></text-box>
                    <text-box
                      label="Číslo lz"
                      :cache="false"
                      :max="12"
                      v-model="cisloLz"
                    ></text-box>
                    <dynamic-combo
                      dynamic
                      clearable
                      multiple
                      :cache="false"
                      dataId="liw_filip__obc_pripady__filter_stav_lz"
                      v-model="stavLz"
                      autoload
                      lite
                    ></dynamic-combo>
                    <dynamic-combo
                      dynamic
                      clearable
                      :cache="false"
                      dataId="liw_filip__obc_pripady__filter_dimenzia"
                      v-model="dimenzia"
                      autoload
                      lite
                    ></dynamic-combo>
                    <dynamic-combo
                      dynamic
                      clearable
                      :cache="false"
                      dataId="liw_filip__obc_pripady__filter_zdroj_ponuky"
                      v-model="zdrojPonuky"
                      autoload
                      lite
                    ></dynamic-combo>
                    <CheckBox
                      class="mt-n16px"
                      label="Je rozpracovaný"
                      v-model="jeRozpracovany"
                    ></CheckBox>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <!-- <v-btn color="primary" text @click="dialog = false">
                    Disagree
                  </v-btn> -->
                  <v-btn class="btn-primary" text @click="applyFilter"> Filtrovať </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
          <!-- ################# -->
          <!-- DIALOG FILTER END -->
          <!-- ################# -->

          <v-btn class="btn-primary right mr-5" @click="applyFilter">Filtrovať</v-btn>
          <v-fade-transition>
            <v-btn
              id="btn-filter-reset"
              v-show="showReset"
              @click="resetFilter"
              class="right btn-secondary mr-5"
              >Resetovať filter</v-btn
            >
          </v-fade-transition>
        </v-col>
      </v-row>
      <!-- {{ datumVytvorenia }} -->
    </v-container>
  </div>
</template>

<script>
import DatePicker from '../../components/basic/DatePicker.vue';
import DynamicCombo from '../../components/basic/DynamicCombo.vue';
import TextBox from '../../components/basic/TextBox.vue';
import CheckBox from '../../components/basic/CheckBox.vue';
import { mapGetters, mapMutations } from 'vuex';
import { eventBus } from '../../main.js';

export default {
  components: {
    DynamicCombo,
    DatePicker,
    TextBox,
    CheckBox,
  },
  props: {},
  methods: {
    ...mapMutations(['setFullTextQuery']),
    showIcon(id) {
      return this.stav.includes(id);
    },
    resetFilter() {
      this.datumVytvorenia = null;
      this.datumModifikacie = null;
      this.stav = [0];
      this.idDodavatela = null;
      this.idStrediska = null;
      this.najomca = null;
      this.ico = null;
      this.cisloObchPripadu = null;
      this.cisloLz = null;
      this.cisloPlz = null;
      this.stavLz = null;
      this.dimenzia = null;
      this.zdrojPonuky = null;
      this.jeRozpracovany = 0;

      this.setFullTextQuery(null);

      this.applyFilter();
    },
    applyFilter() {
      let stavFilter;
      if (this.stav.length === 1 && this.stav[0] === 0) stavFilter = null;
      else stavFilter = this.stav.join();

      let filter = {
        DatumVytvoreniaOd: this.datumVytvorenia
          ? this.datumVytvorenia[0]?.split('-').join('')
          : null,
        DatumVytvoreniaDo: this.datumVytvorenia
          ? this.datumVytvorenia[1]?.split('-').join('')
          : null,
        DatumModifikacieOd: this.datumModifikacie
          ? this.datumModifikacie[0]?.split('-').join('')
          : null,
        DatumModifikacieDo: this.datumModifikacie
          ? this.datumModifikacie[1]?.split('-').join('')
          : null,
        IdStrediska: this.idStrediska,
        IdDodavatela: this.idDodavatela,
        Stav: stavFilter,
        Najomca: this.najomca,
        Ico: this.ico,
        cisloObchPripadu: this.cisloObchPripadu,
        CisloLz: this.cisloLz,
        CisloPlz: this.cisloPlz,
        StavLz: this.stavLz,
        Dimenzia: this.dimenzia,
        ZdrojPonuky: this.zdrojPonuky,
        FullText: this.fullTextQuery ? encodeURIComponent(this.fullTextQuery) : null,
        JeRozpracovany: this.jeRozpracovany ? true : false,
      };

      this.dialog = false;

      this.$emit('filter', filter);
    },
  },
  computed: {
    ...mapGetters(['fullTextQuery']),
    showReset() {
      return (
        this.datumVytvorenia ||
        this.datumModifikacie ||
        !this.stav.includes(0) ||
        this.idStrediska ||
        this.idDodavatela ||
        this.najomca ||
        this.ico ||
        this.cisloObchPripadu ||
        this.cisloLz ||
        this.cisloPlz ||
        this.stavLz ||
        this.dimenzia ||
        this.jeRozpracovany ||
        this.zdrojPonuky ||
        this.fullTextQuery
      );
    },
  },
  watch: {
    stav: function (n) {
      if (n.length === 0) this.stav = [0];
      if (n.includes(0) && n.indexOf(0) !== 0) this.stav = [0];
      if (n.length > 1 && n.indexOf(0) === 0) this.stav.splice(0, 1);
    },
  },
  data() {
    return {
      datumVytvorenia: null,
      datumModifikacie: null,
      idStrediska: null,
      idDodavatela: null,
      najomca: null,
      ico: null,
      cisloObchPripadu: null,
      cisloPlz: null,
      cisloLz: null,
      stavLz: null,
      dimenzia: null,
      zdrojPonuky: null,
      stav: [0],
      dialog: false,
      rules: {
        r1: [val => val || 'Problem'],
      },
      stavFilter: [
        { nazov: 'Všetky', hodnota: 0 },
        { nazov: 'Nový', hodnota: 1 },
        { nazov: 'V riešení', hodnota: 2 },
        { nazov: 'Čakajúci', hodnota: 9 },
        { nazov: 'Realizovaný', hodnota: 6 },
        { nazov: 'Zrušený', hodnota: 8 },
      ],
      jeRozpracovany: 0,
    };
  },
  mounted() {
    eventBus.$on('searchFullText', () => this.applyFilter());

    this.applyFilter();
  },
  beforeDestroy() {
    this.setFullTextQuery(null);
  },
};
</script>
